module.exports = __webpack_public_path__ + "static/media/profile.15c82d56.jpg";